import React from 'react';

import { Alert } from '@components/utils';

const AlertScreen = ({ navigation }) => {
    return <Alert navigation={navigation} />;
};

export { AlertScreen };
